module.exports = __webpack_public_path__ + "static/media/Fundamentals of Electrical Engg..730865bd.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/EEE/Fundamentals of Electrical Engg..pdf
// module id = 127
// module chunks = 0